import React from 'react'
import { observer } from 'mobx-react'
import { CardContent } from 'components/Card'
import Button from 'components/Button'

interface Props {
  showApproveDraftDialog: () => void
  showRejectDraftDialog: () => void
}
export default observer(function DraftInReviewProgressionActions({
  showApproveDraftDialog,
  showRejectDraftDialog,
}: Props) {
  return (
    <>
      <CardContent compactBottomPadding>
        <Button
          type="primary"
          size="wide-slim"
          onClick={showApproveDraftDialog}
          dataTest="job-progression-show-approve-draft-dialog"
        >
          Approve Draft
        </Button>
      </CardContent>
      <CardContent>
        <Button
          type="secondary"
          size="wide-slim"
          onClick={showRejectDraftDialog}
          dataTest="job-progression-show-reject-draft-dialog"
        >
          Reject Draft
        </Button>
      </CardContent>
    </>
  )
})
